import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { api, type ArtefactSummary, type TopicSummary } from '../lib/api.ts'
import { ArtefactIcon } from './ArtefactIcon.tsx'
import { belongsToDepartment, DEPARTMENTS } from '../lib/departments.ts'
import { buildEntries } from '../lib/entries.ts'

/** The hub landing: a director walks into the department that matches the job. */
export function HubLanding() {
  const [artefacts, setArtefacts] = useState<ArtefactSummary[]>([])
  const [topics, setTopics] = useState<TopicSummary[]>([])

  useEffect(() => {
    // A failed count must not blank the page — the departments themselves are
    // static and remain navigable.
    Promise.all([api.catalog(), api.topics()])
      .then(([a, t]) => {
        setArtefacts(a)
        setTopics(t)
      })
      .catch(() => {
        setArtefacts([])
        setTopics([])
      })
  }, [])

  return (
    <main className="catalog">
      <p className="eyebrow">Virtual Central Office</p>
      <h1 className="tool__title">Departments</h1>

      <div className="catalog__grid">
        {DEPARTMENTS.map((department) => {
          const { slug, name } = department
          // Same buildEntries call DepartmentPage renders from, so this count
          // can never disagree with what that page actually lists (a topic
          // collapses to one card here too) — the same class of bug Task 11
          // fixed by sharing belongsToDepartment instead of reimplementing it.
          const deptArtefacts = artefacts.filter((a) => belongsToDepartment(a, department))
          const count = buildEntries(deptArtefacts, topics).length
          return (
            <Link key={slug} to={`/departments/${slug}`} className="card">
              <div className="card__head">
                <p className="card__dept">{count === 1 ? '1 item' : `${count} items`}</p>
                <span className="card__icon" aria-hidden="true">
                  <ArtefactIcon department={name} />
                </span>
              </div>
              <h2 className="card__title">{name}</h2>
            </Link>
          )
        })}
      </div>
    </main>
  )
}
